import './style.css'
import * as THREE from 'three'
import GUI from 'lil-gui'
import gsap from 'gsap'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'


// Debug
//const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color(0xdddddd);
scene.fog = new THREE.Fog(0xdddddd, 5, 50)

//Models
const gltfLoader = new GLTFLoader()
gltfLoader.load(
    '/models/BuddhaBuilding/Buddha.gltf',
    (gltf) =>
    {
        //scene.add(gltf.scene.children[0])
        console.log(gltf)
    }
)

// Geometries
const sideMaterial = new THREE.MeshBasicMaterial({ color: 0xcccccc }) 
const topMaterial = new THREE.MeshBasicMaterial({ color: 0xeeeeee })
const frontMaterial = new THREE.MeshBasicMaterial({ color: 0xdddddd })

function createBuilding(width, length, height, x, z) {
    const geo = new THREE.BoxGeometry(width, height, length);

    geo.translate(width / 2, height / 2, length / 2);

    const materials = [
        frontMaterial, // +x
        frontMaterial, // -x
        topMaterial,  // +y 
        sideMaterial, // -y 
        sideMaterial, // +z
        sideMaterial  // -z
    ]

    const building = new THREE.Mesh(geo, materials);
    
    // Now, position (x, z) refers to the corner
    building.position.set(x - 1.5, 0, z - 1.5);

    return building;
}

const house1 = createBuilding(1.35, 0.52, 0.2, 0, 0);
const house2 = createBuilding(0.49, 0.66, 0.2, 0, 0.67);
const house3 = createBuilding(0.49, 0.36, 0.2, 0, 1.48);
const house4 = createBuilding(0.50, 1, 0.2, 0.2, 1.84);
const house5 = createBuilding(0.38, 1, 0.2, 2, 1.84);
const house6 = createBuilding(0.2, 0.49, 0.2, 2.38, 2.04);
const house7 = createBuilding(0.42, 0.43, 0.2, 2.58, 2.37);
const house8 = createBuilding(0.49, 0.72, 0.2, 2.51, 1.5);
const house9 = createBuilding(0.49, 0.68, 0.2, 2.51, 0.67);
const house10 = createBuilding(0.73, 0.52, 0.2, 2.27, 0);
const house11 = createBuilding(0.49, 0.92, 0.2, 1.63, 0);
const house12 = createBuilding(0.49, 0.36, 0.2, 1.63, 1.07);
const house13 = createBuilding(0.49, 0.36, 0.2, 0.86, 0.67);

const platform1 = createBuilding(1.3, 0.7, 0.1, 0.7, 1.99);
const platform2 = createBuilding(0.42, 0.15, 0.1, 0.85, 1.84);
const platform3 = createBuilding(0.42, 0.15, 0.1, 0.85, 2.69);
const platform4 = createBuilding(0.43, 0.15, 0.1, 1.42, 1.84);
const platform5 = createBuilding(0.43, 0.15, 0.1, 1.42, 2.69);

const block1 = createBuilding(0.15, 0.15, 0.2, 0, 0.52)
const block2 = createBuilding(0.15, 0.15, 0.2, 0, 1.33)
const block3 = createBuilding(0.15, 0.15, 0.2, 1.20, 0.52)
const block4 = createBuilding(0.15, 0.15, 0.2, 1.63, 0.92)
const block5 = createBuilding(0.15, 0.15, 0.2, 2.12, 0)
const block6 = createBuilding(0.15, 0.15, 0.2, 2.85, 0.52)
const block7 = createBuilding(0.15, 0.15, 0.2, 2.85, 1.35)
const block8 = createBuilding(0.15, 0.15, 0.1, 0.2, 3.15)

const wallL = createBuilding(0.02, 3.6, 0.1, -0.4, -0.3)
const wallR = createBuilding(0.02, 3.6, 0.1, 3.4, -0.3)
const wallB = createBuilding(3.8, 0.02, 0.1, -0.4, -0.3)
const wallF = createBuilding(3.2, 0.02, 0.1, 0.2, 3.28)

scene.add(house1, house2, house3, house4, house5, house6, house7, house8, house9, house10, house11, house12, house13, platform1, platform2, platform3, platform4, platform5, block1, block2, block3, block4, block5, block6, block7, block8, wallL, wallR, wallB, wallF);

const width = 0.6
const height = 0.15
const entryX = -0.4
const entryY = 3.3
const geometry = new THREE.PlaneGeometry(width, height)

geometry.translate(width / 2, height / 2, 0)

const entry = new THREE.Mesh(
    geometry,
    new THREE.MeshBasicMaterial({ color: 0xb1f3b1, side: THREE.DoubleSide })
)
entry.rotation.x = -Math.PI / 2
entry.position.set(entryX - 1.5, 0, entryY - 1.5)
scene.add(entry)

const base = new THREE.Mesh(
    new THREE.PlaneGeometry(10000,10000),
    new THREE.MeshBasicMaterial({ color: 0xffffff })
)
base.rotation.x = -Math.PI / 2
base.position.y = - 0.2
scene.add(base)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

/**
 * Camera
 */
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height)

camera.position.set(-3, 2, 3)
camera.lookAt(base.position)
scene.add(camera)

const controls = new OrbitControls(camera, canvas)
controls.maxPolarAngle = Math.PI / 2.5
controls.minPolarAngle = 0
controls.enableDamping = true
controls.screenSpacePanning = false;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// Clock
const clock = new THREE.Clock()

window.addEventListener('resize', () =>{
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

const tick = () => {

    // Time
    const elapsedTime = clock.getElapsedTime()

    // Update camera
    // camera.position.x = Math.sin(cursor.x * Math.PI * 2) * 3
    // camera.position.z = Math.cos(cursor.x * Math.PI * 2) * 3
    // camera.position.y = cursor.y * 5
    // camera.lookAt(group.position)

    controls.update()
    
    renderer.render(scene, camera)

//     // Call tick again on the next frame
     window.requestAnimationFrame(tick)
}

tick()